import Context from '@/plugins/Context'
export const input = {
  computed: {
    valueCmp(){
      return this.value
    },
    label () {
      return this.field.name
    },
    name () {
      return this.field.order
    },
    description () {
      return this.field.description
    }
  },
  props: [ 'field', 'value', 'context', 'isEditing'],
  methods: {
    sendValue (value) {
      this.$emit('setValue', value)
    },
    isFormContext() {
      return this.context.context == Context.FORM
    },
    getParent() {
      if (this.isFormContext()) {
        return this.$parent
      }
      return this.$parent.$parent.$parent.$parent.$parent // TODO refactor
    }
  },
  data: () => {
    return { model: null }
  },
  created () {
    this.model = this.value
  },
  watch: {
    model: function (newValue) {
      if (typeof this.beforeSend === 'function') {
        newValue = this.beforeSend(newValue)
      }
      this.sendValue(newValue)
    }
  }

}
